import RegisterToCourseButton from '../RegisterToCourseButton'
import * as React from 'react'
import { ICourse } from '../../../../../interfaces/ICourse'
import { ISchool } from '../../../../../interfaces/school.interface'
import { IUserDetails } from '../../../../../interfaces/user.interface'
import { IPaymentsPlan } from '../../../../../interfaces/IPaymentsPlan'
import PaymentForCourseButton from '../../../../PaymentComponent/PaymentForCourseButton'
import { Paper, Typography } from '@mui/material'
import { trackFbPixelsAddToCart } from '../../../../../lib/analytics/fbPixels'
import { showCoursePayButtonOnCourseDetailsPage } from '@/services/utils'

export default function StudentUnregisteredActionComponent(props: {
  course_details: ICourse
  schoolDetailsFromCourse: ISchool
  user_details: IUserDetails
  payment_plans: IPaymentsPlan[]
  reloadStudentCourseStatus: (goToClass?: boolean) => void
  openPaymentDetails: boolean
}) {
  // const enableRegisterToCourseButton = React.useMemo<boolean>(() => {
  //   const isSubscriptionOrEnterprise = isSchoolBillingProfileSubscriptionOrEnterprise(
  //     props.school_details
  //   );
  //   if (
  //     isSubscriptionOrEnterprise &&
  //     !props.course_details.disable_direct_registration
  //   ) {
  //     return true;
  //   }
  //
  //   return (
  //     props.course_details.isPublic &&
  //     !props.course_details.disable_direct_registration
  //   );
  // }, []);

  const enableRegisterToCourseButton = React.useMemo<boolean>(() => {
    return !props.course_details.disable_direct_registration
  }, [])

  const enablePaymentButton = React.useMemo<boolean>(() => {
    // const isCommissionOrSubscriptionOrEnterprise = isSchoolBillingProfileCommissionOrSubscriptionOrEnterprise(
    //   props.school_details
    // );

    // we might want to hold people's money till they select a plan
    // if (!isCommissionOrSubscriptionOrEnterprise) {
    //   return false;
    // }

    return (
      Boolean(props.course_details?.price) &&
      !props.course_details.disable_direct_registration &&
      showCoursePayButtonOnCourseDetailsPage({
        courseDetails: props.course_details,
      })
    )
  }, [])

  // const enableCluster = React.useMemo<boolean>(() => {
  //   const isCommissionOrSubscriptionOrEnterprise = isSchoolBillingProfileCommissionOrSubscriptionOrEnterprise(
  //     props.school_details
  //   );
  //
  //   if (!isCommissionOrSubscriptionOrEnterprise) {
  //     return false;
  //   }
  //
  //   return props.payment_plans && props.payment_plans.length > 0;
  // }, []);

  return (
    <React.Fragment>
      {/*  only show register to course if course is public or
      a subscription, enterprise school is true else student have to join a cluster
      */}
      {enablePaymentButton && (
        <Paper
          variant={'outlined'}
          style={{
            padding: '10px 0px',
            backgroundColor: 'inherit',
            // backgroundColor: "#fafafa",
            border: 'none',
            marginTop: '10px',
            // marginBottom: "10px"
          }}
        >
          <div>
            {props.course_details.approve_student_on_payment && (
              <Typography variant={'body2'} align={'center'}>
                You will be automatically approved to the class after payment
              </Typography>
            )}

            <PaymentForCourseButton
              courseDetails={props.course_details}
              school={props.schoolDetailsFromCourse}
              user_details={props.user_details}
              buttonVariant={'outlined'}
              onCloseDialog={props.reloadStudentCourseStatus}
              openDialogByDefault={props.openPaymentDetails}
            />
          </div>
        </Paper>
      )}

      {enableRegisterToCourseButton && (
        <RegisterToCourseButton
          course={props.course_details}
          school={props.schoolDetailsFromCourse}
          onRegisterSuccessful={() => {
            props.reloadStudentCourseStatus(true)
            trackFbPixelsAddToCart(
              props.schoolDetailsFromCourse,
              props.course_details?.name,
            )
          }}
        />
      )}

      {/* {enableCluster && ( */}
      {/*  <PaymentPlansThatCourseBelongTo */}
      {/*    schoolDetails={props.school_details} */}
      {/*    courseDetails={props.course_details} */}
      {/*    paymentPlans={props.payment_plans} */}
      {/*    userDetails={props.user_details} */}
      {/*    refreshStudentBillingData={() => { */}
      {/*      location.reload(); */}
      {/*    }} */}
      {/*  /> */}
      {/* )} */}
    </React.Fragment>
  )
}
